import React from "react";
import styled from "styled-components";

import theme from "../../../styles/theme";

const StyledHeader = styled.header`
  background-color: ${() => theme.colors.green1};
  max-width: 1250px;
  margin: 0px auto;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0px;
  z-index: 1000;
  ${() => theme.media.desktopUp`
    padding: 16px 24px;
  `};
`;

const HeaderContainer = ({ children, className }) => {
  return <StyledHeader className={className}>{children}</StyledHeader>;
};

export default HeaderContainer;
